import {Component, Input, Output, EventEmitter} from '@angular/core';
import {NgForOf} from '@angular/common';
import {SquareButtonComponent} from '../square-button/square-button.component';
import {HoomvipStorage} from '../../../core/hoomvip-storage/hoomvip-storage.service';

@Component({
  selector: 'menu-buttons',
  templateUrl: './menu-buttons.component.html',
  styleUrls: ['./menu-buttons.component.scss'],
  imports: [SquareButtonComponent, NgForOf],
})
export class MenuButtonsComponent {

  @Input() topActions: TopAction[] = [];
  @Output() actionClick = new EventEmitter<any>();

  constructor(
    private hoomvipStorage: HoomvipStorage
  ) {
  }

  onActionClick(action: any, event: Event) {
    if (action.data?.['checkinType']) {
      this.hoomvipStorage.setCheckInType(action.data['checkinType']);
    }
    event.preventDefault();
    this.actionClick.emit(action);
  }

  protected isDisabled(disabled: boolean | undefined) {
    return disabled ?? false;
  }
}
